<template>
  <v-skeleton-loader
    :class="classes"
    v-bind="$attrs"
  ></v-skeleton-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';

export default defineComponent({
  name: 'BaseSkeleton',
  extends: BaseComponent,
});
</script>

<style lang="scss" scoped>
@if mixin-exists("ThemeBaseSkeleton") {
  @include ThemeBaseSkeleton;
}

:deep(.v-skeleton-loader__image) {
  min-height: 100%;
}
</style>
